import { httpServer as http } from "@/lib/axios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 入库核单报表
    async getReportList({ rootState }, params = {}) {
      const data = await http(
        "/scanStoreVerificationOrderReport/paging",
        params
      );
      return data ? data.data || [] : { list: [], total: 0 };
    },
    // 入库核单记录
    async getRecordList({ rootState }, params = {}) {
      const data = await http(
        "/scanStoreVerificationOrderRecord/paging",
        params
      );
      return data ? data.data || [] : { list: [], total: 0 };
    }
  }
};
